// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3ZMsw","header_title":"styles_header_title__2j5gF"};